import { put, select } from 'redux-saga/effects';
import { createMessage } from '../../api/demand/createMessage';
import {
  demandOpenSuccessModal,
  demandRequestCreateMessageEndAction,
  demandRequestCreateMessageErrorAction,
  TCreateMessageStart,
} from '@cian/demand-trap-widget';
import { EStatus } from '../../repositories/demand/v2/create-message';
import {
  verifyPhoneOpenModalAction,
  verifyPhoneSecondsToRetrySmsChangedAction,
  verifyPhoneSetErrorMessageAction,
  EVerifyPhoneError,
  verifyPhoneCloseModalAction,
} from '@cian/sms-validation-widget';
import {
  trackOpenSmsPopup,
  trackPhoneVerificationSuccess,
  trackSendFormSuccess,
  trackVerificationPhoneError,
} from '../../utils/demand/trackDemandEvents';
import { getHttpApi } from '../../selectors/commonSelectors';
import { getTotalPages } from '../helpers/getTotalPagesSaga';

export function* createMessageStart(action: TCreateMessageStart) {
  const { payload } = action;
  const httpApi = yield select(getHttpApi);

  //tslint:disable-next-line:no-any
  const { statusCode, response } = yield createMessage(httpApi, payload as any);

  if (statusCode === 400) {
    yield put(demandRequestCreateMessageErrorAction(response.message));

    return;
  }

  if (statusCode === 200) {
    const isHomeowner = Boolean(payload.isHomeowner);
    yield put(demandRequestCreateMessageEndAction());

    const totalPages = yield getTotalPages();

    switch (response.status) {
      case EStatus.NeedPhoneConfirm:
        trackOpenSmsPopup(isHomeowner, totalPages);
        yield put(verifyPhoneSecondsToRetrySmsChangedAction(response.confirmTimeout));
        yield put(verifyPhoneOpenModalAction());

        return;

      case EStatus.CodeError:
        trackVerificationPhoneError(isHomeowner, totalPages);
        yield put(verifyPhoneSetErrorMessageAction(EVerifyPhoneError.NOT_CORRECT));

        return;

      default:
        if (payload.confirmationCode) {
          trackPhoneVerificationSuccess(isHomeowner, totalPages);
        }

        trackSendFormSuccess(isHomeowner, totalPages);
        yield put(verifyPhoneCloseModalAction());
        yield put(demandOpenSuccessModal());
    }
  }
}
